<template>
  <span
    v-if="outcome.id > 0 || showEmptyOutcome"
    v-on:click.prevent="processOdd()"
    v-bind:class="[
      'bto-sb-event-odd',
      {
        'bto-sb-odd-lock':
          (outcome.outcome === '--' && !showEmptyOutcome) ||
          outcome.active === false ||
          match.isBetStop ||
          checkSuspended(),
        'bto-sb-event-odd-active': checkOddActive() && !match.isBetStop,
        [updateClasses[`class-${outcome.upDownClass}`]]: true,
        'bto-sb-event-odd-x': outcome.name === xOutcomeName,
      },
      quickBetClasses,
    ]">
    <span
      v-if="getQuickBetNotification && getQuickBetNotification.betslip.status === 4"
      class="bto-sb-spinner-v1"></span>
    <template v-if="usShortName && !expandedView">
      <i>{{usShortName}}</i>
      <i>{{formatedOutcome}}</i>
    </template>
    <Fragment v-else-if="!expandedView">
      {{ formatedOutcome }}
    </Fragment>
    <Fragment v-else>
      <i>{{ getExpandedViewOutcomeData }}</i
      ><i>{{ formatedOutcome }}</i>
    </Fragment>
  </span>
</template>

<script>
  import { MARKET_TYPE_IDS } from '../../../models/enums/market-const';
  import store from '../../../store';
  import { formatedOutcomeMixin } from '../../../mixins/global';
  import { toggleItem, toggleAlgoItem, isOddActive, placeQuickBet, getQuickbetPlacementMessage } from '@bto-services/betslip-core';
  import { mapMatchToBetslipItem, mapMatchToBetslipMatchItem, getQuickBetClass, ITEM_TYPES } from 'bto-models/betslip';
  import { showBetslipValidation } from '@bto-services/modal';
  import { formatOddDisplay } from '@bto-services/utils';

  export default {
    name: 'match-odd-live-component',
    data() {
      return {
        updateClasses: {
          'class-1': 'bto-sb-odd-up-2',
          'class--1': 'bto-sb-odd-dw-2',
          'class-0': '',
          'class-': '',
        },
        xOutcomeName: 'Draw1',
        tm: 0,
        activeOutcome: 0,
        changeClass: true,
        louc: '',
        ti: 0,
        IS_AGENT: process.env.VUE_APP_IS_AGENT,
      };
    },
    props: {
      match: {
        type: Object,
        default: () => {
        },
      },
      outcome: {
        type: Object,
        default: () => ({ upDownClass: 0 }),
      },
      odd: {
        type: Object,
        default: () => {
        },
      },
      totalMatchOutcomes: {
        type: Number,
        default: 0,
      },
      expandedView: {
        type: Boolean,
        default: false
      },
      showEmptyOutcome: {
        type: Boolean,
        default: false,
      },
      usShortName: {
        type: String,
        default: '',
      },
      showTeamJerseys: {
        type: Boolean,
        default: false,
      },
      showPlayerTeamName: {
        type: Boolean,
        default: false,
      },
      isPlayerMarket: {
        type: Boolean,
        default: false,
      },
      playerTeamName: {
        type: String,
        default: '',
      },
      isLatam: {
        type: Boolean,
        default: false,
      },
      oName: {
        type: String,
        default: '',
      },
      isWincast: {
        type: Boolean,
        default: false,
      },
      isAgentPlayerMarket: {
        type: Boolean,
        default: false,
      },
      isUsLayout: {
        type: Boolean,
        default: false,
      }
    },
    computed: {
      isThreeWay() {
        let getSportType = store.getters.getSportType;
        return getSportType(this.match.sportId) === MARKET_TYPE_IDS.THREE_WAY;
      },
      /**
       * Check if match is blocked
       */
      isMatchBetStop() {
        return this.match.isBetStop === true;
      },
      /**
       * Build match info if expanded view
       */
      getExpandedViewOutcomeData() {
        if (this.outcome.column === 1) {
          return this.match.homeTeam;
        } else if (this.outcome.column === 2 && this.isThreeWay) {
          return this.$translate.text('W.M.X');
        }
        return this.match.guestTeam;
      },
      formatedOutcome() {
        return formatOddDisplay(this.outcome.originalDecimalOutcome, this.$root.oddFormat);
      },
      getQuickBetNotification() {
        return getQuickbetPlacementMessage({
          matchId: this.match.matchId,
          outcomeId: this.outcome.id,
          marketId: this.odd.marketId,
        });
      },
      quickBetClasses() {
        return getQuickBetClass(this.getQuickBetNotification);
      },
    },
    methods: {
      /**
       * Handle 3 way markets outcome names that have maximum 2 outcomes in it
       */
      hasLessOutcomesInMarket() {
        let totalOutcomesLength = 0;
        if (this.odd.hasOwnProperty('outcomes')) {
          totalOutcomesLength = this.odd.outcomes.length;
        }
        return totalOutcomesLength <= 2;
      },
      /**
       * Select or delete outcomes in match
       */
      processOdd() {
        if (this.outcome.outcome === '--' || this.outcome.active === false || this.match.isBetStop || this.emptyOdd) {
          return;
        }
        if (this.match.suspended || this.outcome.suspended) {
          return;
        }
        const isLive = this.outcome.itemType === ITEM_TYPES.LIVE_PLAYER_SWISH ? false : true;
        const betslip_item = mapMatchToBetslipItem(
          this.match,
          this.outcome,
          this.odd,
          false,
          false,
          false,
          isLive);
        const betslipMatchItem = mapMatchToBetslipMatchItem(this.match, false);
        const error = toggleAlgoItem(betslip_item, betslipMatchItem);
        showBetslipValidation(error);
        if (this.checkOddActive()) {
          placeQuickBet(betslip_item);
        }
      },
      /**
       * Get how many empty outcomes we sould render
       */
      getEmptyOutcomesCount() {
        let len = this.match.odds[0].outcomes.length;
        if (this.totalMatchOutcomes > len) {
          return this.totalMatchOutcomes - len;
        }
        return 0;
      },
      /**
       * Check if odd is active
       */
      checkOddActive() {
        return isOddActive({
          matchId: this.match.matchId,
          outcomeId: this.outcome.id,
          marketId: this.odd.marketId,
        });
      },
      /**
       * Check "suspended" status
       */
      checkSuspended() {
        return this.match.suspended || this.outcome.suspended;
      },
    },
    mixins: [formatedOutcomeMixin]
  };
</script>
